<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';
import './assets/scss/customStyles.scss';

export default {
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val);
    },
  },

  //// TODO use below example to refresh user's accounts on site (re)load

  // async created() {
  //   try {
  //     await this.$auth.renewTokens();
  //   } catch (e) {
  //     console.log(e);
  //   }
  // },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark');
        document.body.classList.add('theme-dark');
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-semi-dark');
      } else {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark');
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark');
      }
    },
    handleWindowResize(event) {
      this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
    },
    removeOverlay() {
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', false);
    },
    emptySelectedAddress() {
      this.$store.commit('UPDATE_SELECTED_ADDRESS', null);
    },
  },
  created() {
    window.addEventListener('load', this.removeOverlay);
    window.addEventListener('load', this.emptySelectedAddress);
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize);
    });
    this.$store.dispatch('updateWindowWidth', window.innerWidth);

    // set color theme for Triple-A
    this.$vs.theme({
      primary: 'rgb(7, 85, 147)',
      success: 'rgb(46,158,81)',
      danger: 'rgb(183, 58, 74)',
      warning: '#ffc107',
      dark: 'rgb(46, 48, 48)',
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
};
</script>
